import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d849100"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "table-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "top-cell"
}
const _hoisted_3 = {
  key: 1,
  class: "top-cell last-cell"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "last-cell"
}

import { PropType } from "vue";
import CustomCard from "./CustomCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomTable',
  props: {
  tableItems: {
    type: Array as PropType<any[]>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomCard, null, {
    default: _withCtx(() => [
      (__props.tableItems.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "table",
              style: _normalizeStyle({
          gridTemplateColumns: `repeat(${
            Object.keys(__props.tableItems[0]).length
          }, auto)`,
        })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(__props.tableItems[0]), (key, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `${index}-header`
                }, [
                  (index != Object.keys(__props.tableItems[0]).length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(key), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(key), 1))
                ], 64))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tableItems, (item, index1) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `${index1}-ticket`
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(item), (key, index2) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: `${index1}-${index2}-col-val`
                    }, [
                      (index2 != Object.keys(__props.tableItems[0]).length - 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item[key]), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item[key]), 1))
                    ], 64))
                  }), 128))
                ], 64))
              }), 128))
            ], 4)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})